import React, { useRef, FC } from 'react'
import { useCarousel } from 'hooks/carousel'
import MobileSwipe from 'components/MobileSwipe'
import PreviousIcon from 'svg/left-caret.svg'
import NextIcon from 'svg/right-caret.svg'
import InsideTheStudioImage from './InsideTheStudioImage'
import styles from '../aboutArtist/AboutArtist.module.scss'
import { StudioImagesType } from '../../types'
import { getScreenWidth } from 'selectors/screen'
import { useSelector } from 'react-redux'

type ImageGalleryProps = {
  studioImages: StudioImagesType
}

const ImageGallery: FC<ImageGalleryProps> = (props) => {
  const { studioImages } = props
  const screenWidth = useSelector(getScreenWidth)
  const isMobile = screenWidth < 500
  const { index, setIndex, prev, next } = useCarousel(studioImages.length) //  next, prev,

  const galleryRef = useRef<HTMLDivElement>(null)
  const element = galleryRef?.current?.getBoundingClientRect?.()?.toJSON?.() || {}
  const elementWidth = element.width || 0
  const offset = index !== 0 && isMobile ? elementWidth * index + 16 * index : elementWidth * index
  return (
    <div data-section='image-gallery'>
      <div data-section='gallery' ref={galleryRef} className={styles.gallery}>
        <MobileSwipe
          minimumDragDistance={50}
          onSwipeComplete={(direction) => {
            direction === 'next' ? next() : prev()
          }}
        />

        <div
          data-section='images'
          style={{
            transform: `translateX(-${offset}px)`,
          }}
        >
          {studioImages.map(({ thumbnailUrl, description }, key) => (
            <InsideTheStudioImage key={key} thumbnailUrl={thumbnailUrl} />
          ))}
        </div>
      </div>

      {studioImages.length > 1 && (
        <div data-section='controls'>
          <PreviousIcon data-type='back' onClick={prev} />
          <NextIcon data-type='next' onClick={next} />
        </div>
      )}

      {studioImages.length > 1 && (
        <div data-section='dots'>
          {studioImages.map((data, key) => (
            <button
              key={key}
              data-type='dot'
              type='button'
              onClick={() => setIndex(key)}
              {...(index === key
                ? {
                    'data-style': 'active',
                  }
                : {})}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ImageGallery
